import styles from "@/elements-react/product-element-refactor/product-element.module.scss";
import { testid } from "@fixparts/testid/index";
import classNames from "classnames";

interface ProductElementTitleProps {
  mpn: string;
  name: string;
}

export const ProductElementTitle = (props: ProductElementTitleProps) => {
  const { mpn, name } = props;

  return (
    <div className={classNames(styles.name)}>
      <div className={styles.mpn} {...testid({ block: "productCard", elm: "line", modifier: "mpn" })}>
        {mpn}
      </div>
      <div className={styles.productName} {...testid({ block: "productCard", elm: "line", modifier: "name" })}>
        {name}
      </div>
    </div>
  );
};
